import { Component, OnInit } from '@angular/core';
import { NgbModalConfig, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { DashService } from '../../../../../app/core/services/dash.service';
import { AppSweetAlert } from '../../../../../app/core/utils/app-sweet-alert';
import { GlobalName } from '../../../../../app/core/utils/global-name';
import { LocalStorageService } from '../../../../../app/core/utils/local-stoarge-service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgxPaginationModule } from 'ngx-pagination';
import { SampleSearchPipe } from '../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../shared/loading/loading.component';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  standalone:true,
  imports:[
     CommonModule,
        FormsModule,
        NgbModule,
        NgxPaginationModule,
        LoadingComponent,
        SampleSearchPipe,
        RouterModule
  ]
})
export class HomeComponent implements OnInit {

data:any[]=[]
loading=false


    constructor(
      private dashService:DashService,
      private toastrService:ToastrService,
        config: NgbModalConfig,
        private lsService:LocalStorageService,
      private modalService: NgbModal) {
       config.backdrop = 'static';
       config.keyboard = false;
       }
  
  

  ngOnInit(): void {
    this.getDash()
  }


   
  getDash(){
    this.loading=true
    this.dashService.getDash().subscribe((res:any)=>{
      this.data=res.data
      this.loading=false
    },
    (err:any)=>{
      this.loading=false

    })
  }


}
